import { useCallback } from 'react';
import { usePostHog } from '@posthog/react';

export type ClassEditEntryPoint = 'class_card_menu' | 'class_details_page' | 'global_class_filter';

export type ClassField = 'name' | 'section' | 'grade' | 'site' | 'icon';

interface ClassUpdate {
  classId: string | null | undefined;
  fieldsChanged: ClassField[];
  entryPoint: ClassEditEntryPoint;
  icon?: string | null;
}

export const useClassUpdatedEvent = (): ((update: ClassUpdate) => void) => {
  const posthog = usePostHog();

  return useCallback(
    ({ classId, fieldsChanged, entryPoint, icon }: ClassUpdate) => {
      if (!classId || !fieldsChanged.length) return;

      posthog?.capture('class_updated', {
        class_id: classId,
        class_fields_changed: fieldsChanged,
        edit_class_entry_point: entryPoint,
        ...(fieldsChanged.includes('icon') && icon ? { class_icon: icon } : {}),
      });
    },
    [posthog],
  );
};
